// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './ColoredDiamondListing.style';
import { GQLCurrencyEnum } from '@scandipwa/scandipwa/src/type/Graphql.type';
import diamond_Shape from 'Src/Value/Diamond_shape';
import Link from '@scandipwa/scandipwa/src/component/Link';
import Loader from '@scandipwa/scandipwa/src/component/Loader';

export class ColoredDiamondListing extends PureComponent {
    static propTypes = {
        diamond: this.propTypes,
        isLoading: this.propTypes
    };

    renderDiamond = (value) => {
        const pricewithcurrency = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: GQLCurrencyEnum.USD,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(Math.round(Number(value?.diamond_price)));

        let shape = "";

        if (value?.diamond_shape) {
            const ShapeName = diamond_Shape?.filter((diamond) => {
                return diamond.code === value?.diamond_shape && diamond.label;
            });

            if (ShapeName.length > 0) {
                shape = ShapeName[0].label;
            }
        }

        return (
            <div className='ColoredDiamondListing-GridProduct'>
                <img src={value?.image_url} />
                <div className='ColoredDiamondListing-DiamondInfo'>
                    <Link to={`view_diamond?diamond_sku=${value?.diamond_sku}`}>
                        <h4>{value?.diamond_carat} Ct. {value?.fancy_color_intensity} {value?.fancy_color_dominant_color} {shape} {value?.diamond_created_from === "12" ? "lab grown " : ""} Diamond</h4>
                    </Link>
                    <span>{pricewithcurrency}</span>
                </div>
            </div>
        )
    }

    render() {
        const { diamond, isLoading } = this.props;

        return (
            <div className="ColoredDiamondListing">
                <div className='ColoredDiaond-Count'>
                    <span>{isLoading ? "Loading.... " : diamond?.total_items} Diamonds</span>
                </div>

                {
                    diamond?.product?.length <= 0 && !isLoading ? <>
                        <h1>No diamond found</h1>
                    </> : <div className='ColoredDiamondListing-GridView'>
                        {
                            diamond?.product?.map((value, index) => (
                                this.renderDiamond(value)
                            ))
                        }
                    </div>
                }

                {isLoading && <div className='Diamond-Loader'><Loader /></div>}
            </div>
        );
    }
}

export default ColoredDiamondListing;
